export default "__VITE_ASSET__Ddb70FBC__"